import { useState } from 'react';
import CreateSetModal from 'library/components/modal/color';
import AddToSetModal from 'library/components/modal/pick-entity';
import { createSet } from 'store/set/actions';
import { useDispatch } from 'react-redux';
import {
  CreateNewButton,
  IconPlus,
  CreateNewButtonContainer,
} from 'library/components/modal/styles';
import * as yup from 'yup';

const newSetValidation = yup.object().shape({
  name: yup
    .string()
    .required('Set name is required field')
    .min(2, 'Name is too short')
    .max(30, 'Name is too long'),
  color: yup.string(),
});

const PickAndCreateSet = ({
  isOpened,
  isLoading,
  onClose,
  onSubmit,
  options,
  onSearch,
  validation,
  defaultValue,
}) => {
  const [isCreateModalOpened, setCreateModalOpened] = useState(false);
  const dispatch = useDispatch();
  const handleCreateSetModalOpen = () => {
    setCreateModalOpened(true);
  };

  const handleCreateSetModalClose = () => {
    setCreateModalOpened(false);
  };

  const handleCreateSet = (data) => {
    handleCreateSetModalClose();

    dispatch(createSet({ data, shouldUpdateBrowseItems: false }));
  };

  const addButton = (
    <CreateNewButtonContainer>
      <CreateNewButton type="button" onClick={handleCreateSetModalOpen}>
        <IconPlus className="icon-plus" />
        Create new set
      </CreateNewButton>
    </CreateNewButtonContainer>
  );

  return (
    <>
      <>
        {
          !isCreateModalOpened
            ? (
              <AddToSetModal
                isSetList
                text=""
                name="sets"
                title="Add item to set(s)"
                placeholder="Search for sets"
                submitText="Save changes"
                cancelText="Cancel"
                overlayClassName="Overlay"
                cancelWidth="94px"
                isMultipleAllowed
                isOpened={isOpened}
                isLoading={isLoading}
                onClose={onClose}
                onSearch={onSearch}
                onSubmit={onSubmit}
                options={options}
                validation={validation}
                defaultValue={defaultValue}
                customButton={addButton}
              />
            ) : null
        }
        {
          isCreateModalOpened
            ? (
              <CreateSetModal
                isPrior
                title="Create new set"
                iconClassName="icon-pencil"
                submitText="Create new set"
                cancelText="Cancel"
                overlayClassName="Overlay"
                placeholder="Come up with a name for your set"
                isOpened={isCreateModalOpened && isOpened}
                onClose={handleCreateSetModalClose}
                onSubmit={handleCreateSet}
                validation={newSetValidation}
              />
            ) : null
        }
      </>
    </>
  );
};

export default PickAndCreateSet;
